<template>
  <v-container fluid>
    <div class="headline-container">
      <v-row>
        <div class="headline-container">
          <span class="headline">Surat Masuk Pimpinan</span>
        </div>
        <v-spacer></v-spacer>
        <v-col cols="6" md="2">
          <v-btn
            rounded
            color="default"
            class="mr-4"
            @click="$refs.laporan.show()"
          >
            <v-icon left color="primary">
              mdi-printer
            </v-icon>
            CETAK LAPORAN
          </v-btn>
        </v-col>
        <v-col cols="6" md="3">
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn rounded color="primary" v-bind="attrs" v-on="on">
                <v-icon left>
                  mdi-pencil
                </v-icon>
                INPUT SURAT PIMPINAN
                <v-icon style="margin-left: 10px; font-size: 18px">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in jenisSurat"
                :key="index"
                @click="onAddButtonPressed(item)"
              >
                <v-list-item-title>{{
                  item.code.toUpperCase()
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>
    <v-card>
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <surat-masuk-list
            ref="suratMasukList"
            @handle-snackbar="emitSnackBar"
            id="suratMasukList"
          />
        </v-container>
      </v-card-text>
    </v-card>
    <surat-masuk-form
      ref="formSurat"
      @submited="onFormSubmited"
      @handle-snackbar="emitSnackBar"
    />
    <laporan ref="laporan" />
  </v-container>
</template>

<script>
import SuratMasukList from '@/components/SuratMasukPimpinan/List'
import Laporan from '@/components/SuratMasuk/Laporan'
import SuratMasukForm from '@/components/SuratMasukPimpinan/Form'
import { mapGetters } from 'vuex'

export default {
  components: {
    SuratMasukList,
    Laporan,
    SuratMasukForm
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['hasPrivateAccess', 'jenisSurat'])
  },
  async mounted() {
    this.$store.dispatch('loadJabatan')
  },
  methods: {
    emitSnackBar(text, color) {
      this.$emit('handle-snackbar', text, color)
    },
    onAddButtonPressed(jenis) {
      this.$refs.formSurat.show(jenis)
    },
    onFormSubmited(isEdit = false) {
      this.$refs.suratMasukList.loadData(isEdit ? undefined : 1)
    }
  }
}
</script>

<style lang="sass" scoped></style>
